<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { ref, computed, useId } from 'vue'
import { useBreakpoint } from "@/app/Checkout/composables/useBreakpoint"

const props = defineProps({
  modelValue: [String, Number],
  label: String,
  labelId: String,
  type: {
    type: String,
    default: 'text'
  },
  disabled: Boolean,
  error: String,
  isHidden: Boolean,
  autocomplete: String,
  name: String
})
const { isMobile } = useBreakpoint()

const emit = defineEmits(['update:modelValue', 'clear-error'])

const isFocused = ref(false)

const hasValue = computed(() => {
  return props.modelValue !== null &&
         props.modelValue !== undefined &&
         props.modelValue !== ''
})

const onInput = (e) => {
  let value = e.target.value

  if (props.type === 'number') {
    value = value === '' ? '' : Number(value)
  }

  emit('update:modelValue', value)

  if (value) {
    emit('clear-error')
  }
}

const id = props.labelId || useId()
</script>
